/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import { faRetweet, faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { Merchant, Error } from "../../models";
import { AuthService, MerchantService, NotificationService } from "../../services";
import { MERCHANT_CONSTANTS } from "../../utils/data.rest.constants";

@Component({
  selector: "app-merchant-details",
  templateUrl: "./merchant-details-parent.component.html"
})
export class MerchantDetailsParentComponent implements OnInit {
  merchant!: Merchant;
  loaded = false;
  activateActionInProgress = false;

  faEditPencil = faEdit;
  faRetweet = faRetweet;
  faPlus = faPlus;
  faTrash = faTrashAlt;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public merchantService: MerchantService,
    public notificationService: NotificationService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.merchant = history.state.merchant;
    if (!this.merchant) {
      this.merchantService
        .getMerchantDetails(Number(this.activatedRoute.snapshot.paramMap.get("merchantId")))
        .subscribe(
          (merchant) => {
            this.merchant = merchant;
            this.loaded = true;
          },
          (error) => {
            this.notificationService.error(error.error);
            this.router.navigate(["/merchants"]);
          }
        );
    } else {
      this.merchantService.merchant = this.merchant;
      this.loaded = true;
    }
    if (!this.merchantService.apiCustomers) {
      this.merchantService.getPayApiCustomers();
    }
  }

  isWorldPay(): boolean {
    return this.merchantService.isWorldPay(this.merchant);
  }

  isInstaMed(): boolean {
    return this.merchantService.isInstaMed(this.merchant);
  }

  isUserBase(): boolean {
    return this.authService.isUserBase();
  }

  isMerchantActive(): boolean {
    return this.merchant.status === "ACTIVE";
  }

  hasFinanceRole(): boolean {
    return this.authService.canUserAccess("FINANCE");
  }

  hasImplementationRole(): boolean {
    return this.authService.canUserAccess("IMPLEMENTATION");
  }

  isPaypal(): boolean {
    return this.merchant.accountDetails.preferredProcessor?.toLowerCase() === MERCHANT_CONSTANTS.PAYPAL.toLowerCase();
  }

  isQbpay(): boolean {
    return this.merchant.accountDetails.preferredProcessor?.toLowerCase() === MERCHANT_CONSTANTS.QBPAY.toLowerCase();
  }

  setFeeDetailsToNullIfNoneExist(merchant: Merchant): void {
    if (merchant.accountDetails.feeAccountDetails && !merchant.accountDetails.separateFundingAccounts) {
      delete merchant.accountDetails.feeAccountDetails;
    }
  }

  updateStatus(status: string): void {
    this.activateActionInProgress = true;

    this.merchantService.updateMerchantStatus(this.merchant.id, status).subscribe(
      (updatedStatusData) => {
        this.merchant.status = updatedStatusData.status;
        this.merchant.deactivatedDate = updatedStatusData.deactivatedDate;
      },
      (error: Error) => {
        this.notificationService.error(error.error);
      }
    );
  }
}
